import { CampaignConfigBuilder } from "@/core/Campaign/config/CampaignConfigModel"
import Topup2c2pService from "../../service/Topup2c2pService"

export default function (states, routeParams) {
    const loadCampaignDetail = function () {
        let builder = new CampaignConfigBuilder()
 
        if (routeParams.campaignId) {
            builder.setCampaignId(routeParams.campaignId)
        }
        return new Promise((resolve) => {
            if (routeParams.campaignId) {
                Topup2c2pService.apiGetCampaignDetail(states.query.token, builder.create(), states.query.appId, states.blobWebLanding, states.query.jwt).subscribe({
                    next: (res) => {
                        states.campaign = res
                        resolve(true)
                    },
                    error: (err) => {
                        states.campaign = null
                        console.log(err)
                        resolve(false)
                    }
                });
            } else {
                states.campaign = null
                resolve(false)
            }
        })
    }

    return {
        loadCampaignDetail
    }
}
